import { render, staticRenderFns } from "./OperatorCampPlacement.vue?vue&type=template&id=08dcbb54&lang=pug&"
import script from "./OperatorCampPlacement.vue?vue&type=script&lang=js&"
export * from "./OperatorCampPlacement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports